<template>
  <div class="step-transfer">
    <div class="content-top">
      <div class="content-top-left">
        <h2 class="title">执行动作</h2>
        <div class="content-main">
          <div>
            <el-input
              v-model="roleName"
              placeholder="请输入动作名称"
              clearable
              class="input-with-select"
            >
            </el-input>
          </div>
          <el-scrollbar class="scroll-bar">
            <div class="transfer-list-left transfer-list">
              <el-checkbox-group v-model="leftChecked" :disabled="disabled">
                <el-row
                  v-for="(item, index) in sourceList"
                  :key="index"
                  class="transfer"
                  :title="item[props.label]"
                >
                  <el-col :span="24">
                    <el-checkbox
                      style="
                        position: relative;
                        width: 100%;
                        height: 30px;
                        line-height: 30px;
                      "
                      :key="item[props.key]"
                      :label="item[props.key]"
                    >
                      {{ item[props.label] }}
                      <div style="position: absolute; top: 24%; right: 0">
                        <span
                          class="el-icon-delete"
                          v-if="item.planStepType === 1"
                          style="margin-right: 10px; width: 17px"
                          @click="deleteStep(item)"
                        ></span>
                      </div>
                    </el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div class="content-top-middle">
        <div style="text-align: center; margin-bottom: 30px">
          <img
            src="@src/common/assets/images/arrows_left.png"
            @click="transferPerson('left')"
            style="cursor: pointer"
            alt=""
          />
        </div>
        <div style="text-align: center">
          <img
            src="@src/common/assets/images/arrows_right.png"
            @click="transferPerson('right')"
            alt=""
            style="cursor: pointer"
          />
        </div>
      </div>

      <div class="content-top-right" :class="type">
        <h2 class="title">已选动作</h2>
        <div class="content-main">
          <div>
            <el-input
              placeholder="请输入动作名称"
              v-model="selectRoleName"
              clearable
              class="input-with-select"
            >
            </el-input>
          </div>
          <el-scrollbar class="scroll-bar">
            <div class="transfer-list-right transfer-list">
              <el-checkbox-group v-model="rightChecked" :disabled="disabled">
                <el-row
                  v-for="(item, index) in targetList"
                  :key="item[props.key]"
                  class="transfer"
                  :title="item[props.label]"
                >
                  <el-col
                    style="
                      display: flex;
                      align-items: center;
                      position: relative;
                      width: 100%;
                      height: 30px;
                      line-height: 30px;
                    "
                  >
                    <el-checkbox :key="item[props.key]" :label="item[props.key]">
                      {{ item[props.label] }}
                      <span
                        v-if="item.value == 6"
                        :title="
                          checkRadioData2
                            ? '已配置设备：' + checkRadioData2.sourceTerminalName
                            : '未配置源终端'
                        "
                        @click.stop="onSetDevice"
                        style="margin-left: 10px; color: #409eff"
                        >{{ checkRadioData2 ? "已配置" : "未配置" }}</span
                      >
                    </el-checkbox>
                    <div
                      v-if="!isOperation"
                      style="position: absolute; top: 24%; right: 0"
                    >
                      <img
                        v-if="index !== 0"
                        style="margin-right: 10px; width: 17px"
                        @click="moveUpClick(index)"
                        src="@/modules/reserve/image/move_up.svg"
                      />
                      <img
                        type="text"
                        v-if="index !== targetList.length - 1"
                        @click="moveDownClick(index)"
                        src="@/modules/reserve/image/move_down.svg"
                        style="width: 17px"
                      />
                    </div>
                    <div v-else>
                      <!--{{scope.row.order}}-->
                    </div>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <!--选择源终端 -->
    <el-dialog
      class="source-dialog"
      title="配置源终端"
      :append-to-body="true"
      :visible.sync="sourceDialog"
      width="700px"
      :before-close="closeSourceDialog"
    >
      <div style="height: 300px">
        <el-scrollbar style="height: 100%">
          <ioc-table
            ref="deviceData"
            :data="deviceTable"
            @radio-change="deviceOnRadio"
            :option="tableOption"
          >
          </ioc-table>
        </el-scrollbar>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeSourceDialog">取消</el-button>
        <el-button type="primary" @click="saveSourceDialog">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
export default {
  name: "stepTransfer",
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    titles: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    props: {
      type: Object,
      default() {
        return {
          label: "label",
          key: "value",
          disabled: "disabled",
          children: "children",
        };
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableOption: {
        rowKey: "templateCode",
        radio: true, //单选
        // index: true,
        // indexLabel: "序号",
        column: [
          {
            label: "设备名称",
            prop: "thirdDeviceName",
          },
          {
            label: "设备状态",
            prop: "statusName",
          },
          // {
          //   label: "源终端",
          //   prop: "sourceTerminalName",
          // },
        ],
      },
      deviceTable: [],
      sourceDialog: false,
      isOperation: false,
      checked: [],
      leftChecked: [],
      rightChecked: [],
      leftTreeSelect: [],
      rightTreeSelect: [],
      roleName: "",
      checkRadioData: null,
      checkRadioData2: null,
      selectRoleName: "",
    };
  },
  computed: {
    sourceList() {
      const ret = this.data.filter((item) => {
        return (
          item[this.props.label] &&
          item[this.props.label].indexOf(this.roleName.trim()) > -1 &&
          !this.value.includes(item[this.props.key])
        );
      });
      return ret;
    },
    targetList() {
      const data = this.data.filter((item) => {
        return (
          item[this.props.label] &&
          item[this.props.label].indexOf(this.selectRoleName.trim()) > -1 &&
          this.value.includes(item[this.props.key])
        );
      });
      // console.log(this.data, "this.data");
      // console.log(data, "data");
      const ret = [];
      this.value.forEach((item) => {
        const index = data.findIndex((item1) => item1.value == item);
        if (index > -1) {
          ret.push(data[index]);
        }
      });
      // console.log(ret, "ret");
      return ret;
    },
  },

  watch: {
    targetList() {
      this.rightChecked = [];
      this.dateChange();
    },
    sourceList() {
      this.leftChecked = [];
    },
  },
  mounted() {
    this.getDevice();
  },
  methods: {
    getDevice() {
      this.$fetch(api.getCallDevice, {
        deviceType: 26,
        page: 1,
        pageSize: 1000,
      }).then((res) => {
        if (res.success) {
          this.deviceTable = res.returnObj.list || [];
        } else {
          this.$message.error(res.msgContent || "查询源终端列表失败");
        }
      });
    },
    deviceOnRadio(val) {
      this.checkRadioData = val;
      console.log(val);
    },
    closeSourceDialog() {
      this.sourceDialog = false;
      this.checkRadioData = null;
    },
    saveSourceDialog() {
      if (!this.checkRadioData) {
        this.$message.warning("请选择设备终端");
        return;
      }
      this.checkRadioData2 = Object.assign({}, this.checkRadioData);
      this.closeSourceDialog();
      this.$emit("checkTemplate", this.checkRadioData2);
    },
    onSetDevice(e) {
      e.preventDefault(); //阻止默认行为
      this.sourceDialog = true;
      this.$nextTick(() => {
        if (!this.checkRadioData2) {
          this.$refs.deviceData.templateRadio = "";
          return;
        }
        let thirdDeviceId =
          this.checkRadioData2.sourceTerminalId || this.checkRadioData2.thirdDeviceId;
        let checkIndex = this.deviceTable.findIndex((el) => {
          return el.thirdDeviceId == thirdDeviceId;
        });
        if (checkIndex != -1) {
          this.$refs.deviceData.templateRadio = checkIndex;
        }
      });
    },

    dateChange() {
      this.$emit("changeData", this.targetList);
    },
    // 向上移动
    moveUpClick(index) {
      if (this.disabled) {
        return;
      }

      if (index > 0 && !this.isOperation) {
        const keys = this.targetList.map((item) => item.value);
        let upDate = keys[index - 1];
        keys.splice(index - 1, 1);
        keys.splice(index, 0, upDate);
        this.$emit("update:value", keys);
      }
    },
    // 向下移动
    moveDownClick(index) {
      if (this.disabled) {
        return;
      }
      if (!this.isOperation) {
        const keys = this.targetList.map((item) => item.value);
        let downDate = keys[index + 1];
        keys.splice(index + 1, 1);
        keys.splice(index, 0, downDate);
        this.$emit("update:value", keys);
      }
    },

    checkChildren(list) {
      let keys = [];
      keys = list.map((item) => item[this.props.key]);
      if (list[this.props.children] && list[this.props.children].length) {
        let keys2 = this.checkChildren(list[this.props.children]);
        keys = keys.concat(keys2);
      }
      return keys;
    },

    // 移动人员
    transferPerson(type) {
      if (type === "left") {
        const remain = [];
        this.targetList.forEach((item) => {
          if (!this.rightChecked.includes(item.value)) {
            remain.push(item.value);
          }
        });
        this.$emit("update:value", remain);
      } else {
        this.$emit("update:value", [...this.value, ...this.leftChecked]);
      }
    },

    deleteStep(value) {
      this.$emit("deleteStep", value.planStepId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.step-transfer {
  // margin-top: 24px;
  .content {
    &-top {
      height: 380px;
      display: flex;
      justify-content: space-between;
      &-left,
      &-right {
        @include set_theme_color(background-color, page-default-bg);
        overflow: hidden;
        h2 {
          // @include set_theme_color(background-color, input-disabled-bg-color);
          margin-bottom: 0;
        }
        .account {
          line-height: 24px;
          padding: 0 10px;
          text-align: left;
        }
        .group-list {
          // height: 300px;
          // overflow-y: scroll;
          overflow: hidden;
        }
        .transfer-list {
          text-align: left;
          // padding: 5px 10px 10px;
          overflow: hidden;
          .transfer {
            padding: 6px;
            border-bottom: 1px solid #dcdfe6;
            display: flex;
            flex-direction: row;
            align-items: center;
            .el-checkbox__label {
              display: block;
              // vertical-align: middle;
              max-width: 260px;
              width: 100%;
              // display: flex;
              // justify-content: space-around;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              .name {
                width: 120px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
      &-middle {
        width: 70px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-content: center;
        .to-left {
          // margin: 100px 0px 10px 0px;
          background: transparent;

          @include set_theme_color(color, active-border-color);
        }
        .to-right {
          // margin-left: 2px
          background: transparent;
          @include set_theme_color(color, active-border-color);
          // background: transparent;
        }
      }
      .date {
        flex: 1;
        width: 360px;
      }
    }
  }
  .content-main {
    height: calc(100% - 30px);
    padding: 10px;
    // background: #0d121c;
  }
  .content-top-middle {
    width: 55px;
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .scroll-bar {
    height: calc(100% - 55px);
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .dialog {
    .el-dialog__body {
      padding: 30px 0 0 0;
      background: rgb(53, 84, 134);
    }
  }
  .footer {
    text-align: right;
    padding: 20px 20px 20px 0;
    background: rgb(35, 57, 94);
  }
  .title {
    height: 32px;
    // color: #fff;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    font-weight: normal;
  }
  .right-title {
    height: 48px;
    line-height: 48px;
  }
  .tree-list .personwidth {
    max-width: 220px;
    // overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tree-list .el-tree .is-current > .el-tree-node__content,
  .tree-list .el-tree-node__content:hover {
    background-color: transparent;
  }
  .transfer-list .el-checkbox__input.is-checked + .el-checkbox__label {
    // color: #c9d5ec;
  }
  .expand {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 2px;
    border: 1px solid #b3cbf1;
  }

  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: auto;
  }

  .content-top-left {
    position: relative;
  }
  .content-top-left .el-icon-plus {
    position: absolute;
    top: 8px;
    right: 14px;
    color: #fff;
  }
  .step-input {
    margin: 8px 0 5px 15px;
  }
  .step-input .input {
    border: 1px solid rgb(88, 157, 246);
    height: 27px;
  }
  .step-input .input {
    width: 160px;
    color: #fff;
  }
  .step-input span {
    font-size: 16px;
    color: rgb(88, 157, 246);
  }
  .step-input .el-icon-check {
    font-size: 16px;
    margin: 0 6px;
  }
  .select-role {
    text-align: center;
    @include set_theme_color(color, font-default-color);
  }

  .date-range-column {
    display: flex;
    flex-direction: row;
  }

  .el-checkbox {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .el-checkbox__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-date-editor .el-range-separator {
    width: 25px;
  }
}
</style>
